/**
 * Shared behavior for the ordering overlays (cart drawer, item sheet, checkout):
 * Escape closes, and the page behind doesn't scroll while one is open.
 */
import { useEffect } from 'react';

let locks = 0;

export function useOverlay(open, onClose) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    // Counted, so stacked overlays (sheet over drawer) release the page only
    // when the last one closes.
    if (locks++ === 0) document.body.classList.add('ord-noscroll');
    return () => {
      document.removeEventListener('keydown', onKey);
      if (--locks === 0) document.body.classList.remove('ord-noscroll');
    };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
}
